import styled from 'styled-components';
import { Link } from 'gatsby';

export const MobileMenu = styled.ul`
  text-align: center;
  list-style: none;
  margin: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(250, 171, 6, .9);
  z-index: 999;
  padding-top: 50px;

  .close-menu {
    position: absolute;
    right: 20px;
    top: 20px;
  }

  li {
    display: block;
  }

  a {
    color: #fff;
    text-decoration: none;
    font-size: 24px;
    display: block;
    padding: 30px 0;
  }
`;

export const Logo = styled(Link)`
  display: block;
  font-family: Playfair Display;
  font-size: 36px;
  line-height: 1;
  font-weight: 900;
  margin-top: 30px;
  color: #666;
  text-decoration: none;
`;

export const MobileOpenMenu = styled.div`
  text-align: right;
  margin: 55px 25px 0 0;
`;

export const DesktopMenu = styled.ul`
  text-align: right;
  list-style: none;
  margin-top: 55px;

  li {
    display: inline-block;
    margin-left: 20px;
  }

  a {
    color: #999;
    text-decoration: none;
    font-size: 17px;
  }
`;
